<template>
  <Transition name="fade">
    <UButton
      v-show="isVisible"
      :class="mergedButtonClasses"
      @click="scrollToTop"
    >
      <UIcon name="i-fluent:arrow-up-24-filled" class="text-xl" />
    </UButton>
  </Transition>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    buttonAttrs?: Record<string, any>
    threshold?: number
  }>(),
  {
    threshold: 500,
  },
)

const isVisible = ref(false)

function handleScroll() {
  isVisible.value = window.scrollY > props.threshold
}

const mergedButtonClasses = twMerge(
  'sm:h-12 sm:w-12 h-10 w-10 bg-primary text-white flex items-center justify-center fixed bottom-4 right-16 sm:bottom-10 sm:right-32 duration-300 z-20',
  props.buttonAttrs?.class,
)

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
